import { useMediaQuery, useTheme } from '@mui/material'

export const useScreenSize = () => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
    // const isTabled = useMediaQuery(theme.breakpoints.up('sm') && theme.breakpoints.down('md'))

    // const buttonSize = isMobile ? 'small' : isTabled ? 'medium' : 'large'

    return { isMobile, isDesktop }
}
